import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { Service } from 'Components/widgets/product-services/product-service/ProductService';
import { ProductService } from 'Components/widgets/product-services/product-service/ProductService';
export type Props = {
  className?: string;
  services: ReadonlyArray<Service>;
};
export const PriceRemoteServiceList = ({ className, services }: Props) => (
  <div className={classnames('flex flex-col gap-10', className)}>
    {services.map((service: Service) => (
      <ProductService key={service.label} service={service} />
    ))}
  </div>
);
